import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _AdvertiseImgIndividualBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 广告图片的宽度 */
  ['--advertse-img-individual-width']?: string;
  /** 广告图片的高度 */
  ['--advertse-img-individual-height']?: string
}
